import React, { useEffect, useRef, useState } from 'react';
import { ColDef, GridOptions } from 'ag-grid-community';
import { AgGridReact } from 'ag-grid-react';
import { useAgGridCommon } from '../../../common/table/agGrid/AgGridCommon';
import { common, mergeGridOpts } from 'utils/agGrid/options';
import { useAppSelector } from 'hooks/useAppSelector';
import { createLoadingSelector } from 'erisxkit/client';
import { FCM_MARGIN_CALL_REQUIREMENTS } from 'constants/actionTypes';

export interface MarginRequirements {
  time: string;
  tradeDate: string;
  type: string;
  firmCode: string;
  accountCode: string;
  accountType: string;
  origin: string;
  marginRequirement: string;
  overrideComment: string;
  spanMarginRequirement: string;
  spanMarginRequirementOverride: string;
  guarantyFund: string;
  guarantyFundOverride: string;
  concentrationAddOn: string;
  concentrationAddOnOverride: string;
  stressAddOn: string;
  stressAddOnOverride: string;
  cover_2AddOn: string;
  cover_2AddOnOverride: string;
  discretionaryAddOn: string;
  discretionaryAddOnOverride: string;
}

interface MarginRequirementsFileGridProps {
  data: MarginRequirements[];
  colDefs: ColDef[];
  loading?: boolean;
}

const gridOpts = mergeGridOpts(common, {
  autoSizeStrategy: { type: 'fitCellContents' },
});

export const gridName = 'margin-requirements';

const MarginRequirementsGrid: React.FC<MarginRequirementsFileGridProps> = ({
  data,
  colDefs,
}) => {
  const gridRef = useRef<AgGridReact>(null);
  const [rowData, setRowData] = useState<MarginRequirements[]>([]);
  const [columnDefs, setColumnDefs] = useState<ColDef[]>([]);
  const loading = useAppSelector((state) =>
    createLoadingSelector([FCM_MARGIN_CALL_REQUIREMENTS])(state),
  );
  useEffect(() => {
    setColumnDefs(colDefs);
  }, [colDefs]);

  const { gridVisible, initialGridSettings, onStateUpdated, gridButtons } =
    useAgGridCommon({
      gridName,
      gridRef,
    });

  useEffect(() => {
    setRowData(data);
  }, [data]);

  return (
    <div className="ag-theme-quartz">
      {gridVisible && (
        <>
          {gridButtons}
          <AgGridReact
            loading={loading}
            ref={gridRef}
            rowData={rowData}
            columnDefs={columnDefs}
            gridOptions={gridOpts}
            onStateUpdated={onStateUpdated}
            initialState={initialGridSettings}
          />
        </>
      )}
    </div>
  );
};

export default MarginRequirementsGrid;
